/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSessionParamsDTO } from './CreateSessionParamsDTO';
import {
    CreateSessionParamsDTOFromJSON,
    CreateSessionParamsDTOFromJSONTyped,
    CreateSessionParamsDTOToJSON,
} from './CreateSessionParamsDTO';

/**
 * 
 * @export
 * @interface StoragePurchaseRequestDTO
 */
export interface StoragePurchaseRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof StoragePurchaseRequestDTO
     */
    targetStorageSizeGb: number;
    /**
     * 
     * @type {CreateSessionParamsDTO}
     * @memberof StoragePurchaseRequestDTO
     */
    sessionParams: CreateSessionParamsDTO;
}

/**
 * Check if a given object implements the StoragePurchaseRequestDTO interface.
 */
export function instanceOfStoragePurchaseRequestDTO(value: object): value is StoragePurchaseRequestDTO {
    if (!('targetStorageSizeGb' in value) || value['targetStorageSizeGb'] === undefined) return false;
    if (!('sessionParams' in value) || value['sessionParams'] === undefined) return false;
    return true;
}

export function StoragePurchaseRequestDTOFromJSON(json: any): StoragePurchaseRequestDTO {
    return StoragePurchaseRequestDTOFromJSONTyped(json, false);
}

export function StoragePurchaseRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoragePurchaseRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'targetStorageSizeGb': json['targetStorageSizeGb'],
        'sessionParams': CreateSessionParamsDTOFromJSON(json['sessionParams']),
    };
}

export function StoragePurchaseRequestDTOToJSON(value?: StoragePurchaseRequestDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'targetStorageSizeGb': value['targetStorageSizeGb'],
        'sessionParams': CreateSessionParamsDTOToJSON(value['sessionParams']),
    };
}

